var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeqBlueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.67502 15.5L18.1667 8L0.67502 0.5L0.666687 6.33333L13.1667 8L0.666687 9.66667L0.67502 15.5Z",
    fill: "#1E88E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeqBlueIcon);
export default __webpack_public_path__ + "static/media/SeqBlueIcon.fb2594c0417d8a785cebda854837f101.svg";
export { ForwardRef as ReactComponent };